import { createSelector, createSlice } from '@reduxjs/toolkit';
import { selectFolders } from './foldersSlice';
import { selectAllObjects } from './objectsSlice';

const initialState = {
	all: [],
	simple: [],
	activeIds: [],
};

const businessAreasSlice = createSlice({
	name: 'businessAreas',
	initialState,
	reducers: {
		setSimpleBAs: (state, action) => {
			if (action?.payload?.businessAreas) {
				state.simple = action.payload.businessAreas;
				state.activeIds = action.payload.businessAreas.map((ba) => ba.id);
			}
		},
		setBusinessAreas: (state, action) => {
			if (action?.payload?.businessAreas) {
				state.all = action.payload.businessAreas;
			}
		},
		setActiveBusinessAreaIds: (state, action) => {
			if (action?.payload?.businessAreaIds) {
				state.activeIds = action.payload.businessAreaIds;
			}
		},
		resetBusinessAreas: (state) => {
			state.all = initialState.all;
			state.simple = initialState.simple;
			state.activeIds = initialState.activeIds;
		},
	},
});

export default businessAreasSlice.reducer;
export const { setSimpleBAs, setBusinessAreas, setActiveBusinessAreaIds, resetBusinessAreas } = businessAreasSlice.actions;

export const selectActiveBusinessAreaIds = (state) => state.businessAreas.activeIds;
export const selectAllBusinessAreas = (state) => state.businessAreas.all;

export const selectActiveBusinessAreaIdsForAPI = (state) => `[${state.businessAreas.activeIds.map((baId) => `"${baId}"`).join(',')}]`;

export const selectActiveBusinessAreas = createSelector(
	selectAllBusinessAreas,
	selectActiveBusinessAreaIds,
	(allBusinessAreas, activeBusinessAreaIds) => allBusinessAreas.filter((businessArea) => activeBusinessAreaIds.includes(businessArea.id)),
);

export const selectBusinessAreaById = (state, businessAreaId) => state.businessAreas.all?.find((businessArea) => businessArea.id === businessAreaId);

export const selectBusinessAreaByIdWithFolders = createSelector(
	selectBusinessAreaById,
	selectFolders,
	(businessArea, allFolders) => {
		if (businessArea && allFolders) {
			const folders = businessArea.children.map((childId) => allFolders[childId]);
			return { ...businessArea, folders };
		}
		return null;
	},
);

export const selectFeaturedObjectsForBusinessAreaId = createSelector(
	selectBusinessAreaById,
	selectAllObjects,
	(businessArea, allObjects) => {
		if (businessArea?.moreInfoBox?.items) {
			const featuredItems = businessArea?.moreInfoBox?.items.map((featuredItemIdObject) => {
				// TODO: Other types!!
				if (featuredItemIdObject?.type === 'object' && allObjects?.[featuredItemIdObject?.id]) {
					return allObjects?.[featuredItemIdObject?.id];
				}
				return null;
			}).filter((x) => !!x);
			return featuredItems;
		}
		return null;
	},
);
